import { faBarsSort } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface PayerCountAndSortProps {
  count: number;
  sortOrder: 'asc' | 'desc';
  onSortToggle: () => void;
}

export const PayerCountAndSort = ({
  count,
  sortOrder,
  onSortToggle,
}: PayerCountAndSortProps) => {
  return (
    <div className="vai-px-6 vai-py-3 vai-flex vai-items-center vai-justify-between">
      <div className="vai-text-sm vai-text-muted-foreground">
        All Payers ({count})
      </div>
      <button
        onClick={onSortToggle}
        className="vai-flex vai-items-center vai-gap-2 vai-text-muted-foreground hover:vai-text-foreground vai-transition-colors"
      >
        <FontAwesomeIcon icon={faBarsSort} />
        <span className="vai-text-sm">
          {sortOrder === 'asc' ? 'A-Z' : 'Z-A'}
        </span>
      </button>
    </div>
  );
};
